import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RadioButton } from '@models/app/helpers.model';
import { SiqCommonModule } from '@shared/siq-common.module';

@Component({
  selector: 'app-siq-radio-button',
  templateUrl: './siq-radio-button.component.html',
  styleUrls: ['./siq-radio-button.component.scss'],
  standalone: true,
  imports: [SiqCommonModule]
})
export class SiqRadioButtonComponent {
  @Input() selectedOption: number | null;
  @Input() direction = 'column';
  @Input() answer: RadioButton;
  @Output() selected = new EventEmitter<number>();

  isButtonSelected(id: number): boolean {
    return this.selectedOption === id;
  }

  get isColumn(): boolean {
    return this.direction === 'column';
  }

  get textClasses(): string {
    return `siq-text-400 text-center fs-16 white ${this.answer.textWidth}`;
  }

  selectOption(selectedId: number): void {
    this.selectedOption = selectedId;
    this.selected.emit(selectedId);
  }
}
